import { CalendarRange, Building2 } from "lucide-react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../ui/select";
import { Switch } from "../../../ui/switch";
import { useOfficeMapping } from "../lib/api/office-mapping";
import { TIME_RANGES } from "../lib/search";
import { useDashboardSearch } from "../lib/useDashboardSearch";
import { cn } from "../lib/utils";

export function FilterBar() {
  const { range, office, compare, update } = useDashboardSearch();
  const { data: offices } = useOfficeMapping();

  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-border bg-card p-3">
      <div className="flex items-center gap-2">
        <CalendarRange className="size-4 text-primary" />
        <Select value={range} onValueChange={(v) => update({ range: v })}>
          <SelectTrigger className="w-[168px]" aria-label="Time range">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {TIME_RANGES.map((r) => (
              <SelectItem key={r.value} value={r.value}>
                {r.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <div className="flex items-center gap-2">
        <Building2 className="size-4 text-primary" />
        <Select value={office} onValueChange={(v) => update({ office: v })}>
          <SelectTrigger className="w-[240px]" aria-label="Office">
            <SelectValue placeholder="All Offices" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Offices</SelectItem>
            {(offices ?? []).map((o) => (
              <SelectItem
                key={o.officeName}
                value={o.officeName}
                className={cn(!o.liveOnAthena && "text-neutral-inactive")}
              >
                <span className="flex w-full items-center gap-2">
                  <span className={cn(!o.liveOnAthena && "text-neutral-inactive")}>
                    {o.officeName}
                  </span>
                  {!o.liveOnAthena ? (
                    <span className="bg-neutral-inactive-dim px-1.5 py-0.5 text-[0.6rem] font-medium uppercase tracking-wide text-neutral-inactive">
                      Not yet live
                    </span>
                  ) : null}
                </span>
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>

      <label className="ml-auto flex cursor-pointer items-center gap-2 text-xs font-medium text-muted-foreground">
        <Switch
          checked={compare}
          onCheckedChange={(v) => update({ compare: v })}
          aria-label="Compare same period last year"
        />
        Compare same period last year
      </label>
    </div>
  );
}
